import { SteeringGraphKeys } from 'business/steering/pages/table-page/components/chart/steering-graph/types';
import { SteeringDataKeys } from 'business/steering/pages/table-page/components/steering-table/types';

const frontKeys: SteeringGraphKeys = {
  abscissa: SteeringDataKeys.frontHorizontalPosition,
  ordinate: SteeringDataKeys.frontVerticalPosition,
};

const rearKeys: SteeringGraphKeys = {
  abscissa: SteeringDataKeys.rearHorizontalPosition,
  ordinate: SteeringDataKeys.rearVerticalPosition,
};

const cuttingWheelKeys: SteeringGraphKeys = {
  abscissa: SteeringDataKeys.cuttingWheelHorizontalPosition,
  ordinate: SteeringDataKeys.cuttingWheelVerticalPosition,
};

export const graphKeys = {
  front: frontKeys,
  rear: rearKeys,
  cuttingWheel: cuttingWheelKeys,
};

export const graphLegendHeight = 60;

export const graphWidth = 550;
export const graphHeight = graphWidth + graphLegendHeight;

export const mobileGraphWidth = 350;
export const mobileGraphHeight = mobileGraphWidth + graphLegendHeight;
